<template>
  <div :class="navLogoType ? 'h-10' : 'flex flex-col justify-center'">
    <img
      v-if="navLogoType"
      :src="logoPath"
      :alt="altText"
      srcset=""
      class="h-full"
    />
    <div class="mt-2" v-else v-html="navLogoLabel"></div>
  </div>
</template>
<script>
export default {
  name: 'Logo',
  props: {
    logoPath: {
      type: String,
      required: false,
    },
    altText: {
      type: String,
      default: 'Portal Logo',
    },
    navLogoType: {},
    navLogoLabel: {
      type: String,
      default: 'Portal Logo Lable',
    },
  },
};
</script>
